// extracted by mini-css-extract-plugin
export default {"slideContainer":"_2e9c6fbe39 _926bca7c95 b587d0667c","slideImage":"_79f93fdae9"};